import { Button, CustomModal, Dropdown, ProfileInfo } from "../../components";
import { AgentEditController } from "../../controllers";
import { Cancel, Documentupload, Folder, Import, Logout } from "../../../assets";
import { LinearProgress } from "@mui/material";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import { AppConstants } from "../../../core/constants";
import { logout } from "../../../core/service";

class agentEdit extends AgentEditController {
  componentDidMount() {
    window.scrollTo(0, 0);
 
    this.props.dispatch(this.getProfile());
  }

  render() {
    const { loading, upload_list, uploadError , fileUpload , base64Loading} = this.state;
    const { userData } = this.props;
    return (
      <>
        <Helmet>
          <title> آپلود مدارک | بیمه زندگی هامرز</title>
        </Helmet>

        {loading ? (
          <LinearProgress />
        ) : (
          <div className="agent-edit">
            <div className="agent-edit-section">

           
               <div className="d-flex justify-content-between flex-row-reverse">
               <div className="cursor-pointer" onClick={()=>logout()}>
                                   <img alt="هامرز" src={Logout} className="ps-1 " />
                                   خروج
                                 </div>
           
               </div>
              <div className="row-container w-100">
                <span className="agent-edit-section-title d-flex align-items-baseline text-end w-100 ms-0">
                  <> مشخصات نماینده </>
                  <hr className="hr-line" />
                </span>
              </div>
              <div className="agent-edit-info-container border">
              <ProfileInfo
                  myStyle="m-1"
                  title="نام کارگذاری"
                  value={userData?.brag_name}
                />
                <ProfileInfo
                  myStyle="m-1"
                  title="تاریخ شروع"
                  value={userData?.begin_date}
                />
                <ProfileInfo
                  myStyle="m-1"
                  title="تاریخ انقضاء"
                  value={userData?.end_date}
                />
              </div>
<div className="agent-edit-download">
<Button loading={base64Loading} icon={Import} myStyle="download bg-light-blue next-btn loading-spinner-primary " title="قرارداد  " onClick={()=>this.getBragAgreement()} />

</div>

              <div className="agent-edit-upload">
                <div className="row-container w-100">
                  <span className="agent-edit-section-title d-flex align-items-baseline text-end w-100 ms-0">
                    <>  مدارک </>
                    <hr className="hr-line" />
                  </span>
                </div>
                <div className="uploader-container ">

                  <div className="img-container">
                  <Button imageTag={ <img
                            src={Documentupload}
                            className=" ms-1"
                            alt="هامرز"
                          />}  myStyle="bg-light-blue table-btn upload-btn w-50 mt-0" title=" آپلود " onClick={() =>  this.setState({openModal:true})} />

                  </div>
                  <div className="upload-list-section w-100">
                    <div className="error-text w-100">
                      {
                        uploadError.filter(
                          (name: { path: string }) => name.path === `fileUpload`
                        )?.[0]?.errors?.[0]
                      }
                    </div>
                    <div
                      className={`upload-list-cards ${
                        upload_list?.length === 1 ? "single-card" : ""
                      }`}
                    >
                      {upload_list?.map((item: any) => {
                      const fileUrl = `${AppConstants.base_core_url}/${item.attachments_url}`;
                      const isImage = /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(item.attachments_url); // بررسی پسوند                    

                      return (
                        <div key={item.id} className="upload-card">
                          {isImage ?
                          <img
                            src={fileUrl} // نمایش تصویر یا عکس دیفالت PDF
                            alt={item.type}
                            className="upload-card-image"
                          />
                          :
                          <Folder myStyle="upload-card-image"/>
                                          }
                          <div className="upload-card-info">
                            <h3 className="upload-card-title">{item.type}</h3>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  </div>
                </div>
              </div>
        </div>

        </div>

      )}  
      <CustomModal myStyle="offers-upload-modal" openModal={this.state.openModal} onClose={() => this.closeModal()}>
          <>
            <div className="custom-modal-main-title mb-3 ">
              <h1 className="title">
                 مدارک              </h1>
              <Cancel myStyle="hide-desktop ps-2 " width="20" height="20" color="#000000" onClick={() => this.closeModal()} />
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() => this.closeModal()} />
            </div>
            <div className="offers-upload">
                <div className="uploader-container ">
                  <Dropdown
                    isRequired
                    objectList
                    items={this.state.dropdownOptionsUpload.brag_id || []}
                    iconBorder
                    displayEmpty
                    myStyle="inquery-dropdown w-100"
                    lable="  نوع سند دریافتی "
                    placeholder=" نوع سند دریافتی خود را اینجا وارد کنید "
                    value={this.state.upload_type}
                    onChange={(e: any) =>
                      this.setState({ upload_type: e.target.value })
                    }
                  />
{this.state.file ?
                  <div className="file-container">

                    <span className="file-name">{fileUpload?.name}</span>
                    <Button myStyle="remove" title="حذف" onClick={() => this.setState({ fileUpload: "", file: "" })} />

                  </div>
                  :
                  <>
                    <span className="title">
                    لطفاً مدارک خود را از طریق بخش                       <span className="bold title">  بارگذاری ، </span>
                      <br />

                      آپلود کنید                              </span></>


                }
                  <div className="img-container">


                    <div className="file-upload">
                      <div className="file-upload-btn">
                        <label className="file-upload-lable" htmlFor="file-input">
                        <img src={Documentupload}  className="cursor-pointer" alt="هامرز" />
                      </label>
                      <input
                        accept="image/*,.pdf,.excel"
                        type="file"
                        hidden
                        id="file-input"
                        onChange={(event) => this.uploadImage(event)}
                      />
                    </div>

                    <h5 className="file-upload-text"> بارگذاری </h5>
                  </div>
                </div>


                <div className="error-text w-100">
                  {uploadError.filter((name: { path: string; }) => name.path === `fileUpload`)?.[0]?.errors?.[0]}
                </div>
                
              </div>
              <div className="d-flex">
                <Button loading={this.state.inquiryLoading} myStyle="bg-light-blue table-btn upload-btn" title=" آپلود " onClick={() => this.uploadFile()} />
              </div>
            </div>
          </>
        </CustomModal>
      </>
    );
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};

export default connect(mapStateToProps)(agentEdit);
